import { IntakeFormReservedFieldNames } from '../enums';
import { TicketWithoutPaymentDetailsDto, UserDto } from '../models/dto';
import { getUserEmail, getUserName, getUserPhoneNumber } from './user.utils';

export const getAttendeeUserName = (
	ticket?: Pick<TicketWithoutPaymentDetailsDto, 'fullName' | 'intakeFormResults'>,
	order?: { user?: UserDto }
) =>
	(ticket?.intakeFormResults as Record<string, any>)?.[IntakeFormReservedFieldNames.FullName] ||
	ticket?.fullName ||
	getUserName(order?.user);

export const getAttendeeUserEmail = (
	ticket?: Pick<TicketWithoutPaymentDetailsDto, 'email' | 'intakeFormResults'>,
	order?: { user?: UserDto }
) =>
	(ticket?.intakeFormResults as Record<string, any>)?.[IntakeFormReservedFieldNames.Email] ||
	ticket?.email ||
	getUserEmail(order?.user);

export const getAttendeeUserPhoneNumber = (
	ticket?: Pick<TicketWithoutPaymentDetailsDto, 'intakeFormResults'>,
	order?: { user?: UserDto }
) =>
	(ticket?.intakeFormResults as Record<string, any>)?.[IntakeFormReservedFieldNames.PhoneNumber] ||
	getUserPhoneNumber(order?.user);
